import { getCurrentInstance } from 'vue';

/**
 * Provides access to the globally registered PrimeVue Toast service
 * without importing PrimeVue modules inside each component.
 */
export const useToastService = () => {
    const instance = getCurrentInstance();

    if (!instance?.proxy?.$toast) {
        throw new Error('[useToastService] PrimeVue ToastService is not registered. Ensure ToastService plugin is installed in main.js.');
    }

    return instance.proxy.$toast;
};


